import Button from '@root/src/app/designSystem/buttons';
import styled from 'styled-components';
import { colors } from '@root/src/app/layout/design';

export const StyledButton = styled(Button)`
  width: 126px;
  padding: 0px;
`;

export const UploadMobileButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: calc(100% - 40px);
  height: auto;

  border-radius: 10px;
  background: ${colors.lighterGrey};

  aspect-ratio: 5/4;
  color: ${colors.darkGrey};
  text-transform: uppercase;

  margin-top: 24px;
`;

type UploadContainerI = {
  isMobileView: boolean;
};

export const UploadContainer = styled.div<UploadContainerI>`
  margin-left: ${(props) => (props.isMobileView ? '40px' : '24px')};

  > button {
    padding: 0px;
  }
`;
